import { Box, Flex, RadioGroup, Text, Radio } from "@chakra-ui/react";
import { useChangePaymentMethodMutation, usePayInQuery } from "apis";
import { ActionBar, Layout, PageMotion, PositiveInfo, PoweredBy, Span } from "components";
import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router";
import { PayWithBank } from "ui";

interface IProps {
  payId?: string;
  removeHeader?: boolean;
  onClose?: () => void;
}
const Pay = ({ payId, removeHeader, onClose }: IProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const queries = useMemo(() => new URLSearchParams(location?.search), [location]);

  const { data, isSuccess } = usePayInQuery({
    classId: queries.get("class")! ?? "1",
    txId: payId ? payId : queries.get("txid")! || queries.get("txId")!,
  });

  // const defaultValue = useMemo(() => {
  //   const filter = data && data.paymentMethods.filter(({ selected }) => selected === true);
  //   return filter && filter[0].value;
  // }, [data]);

  const [_changePaymentMethod] = useChangePaymentMethodMutation();

  const handlePaymentMethod = async (paymentMethod: string) => {
    await _changePaymentMethod({
      paymentId: data?.paymentId!,
      paymentMethod,
    });
  };

  const tabData = [
    {
      label: "Bitmama Wallet",
      value: "bitmama",
      selected: false,
      extraFee: 0,
      disabled: true,
    },
    {
      label: "Bank Account",
      value: "bank",
      selected: true,
      extraFee: 100,
      disabled: false,
    },
    {
      label: "Mobile Money",
      value: "mobilemoney",
      selected: false,
      extraFee: 0,
      disabled: true,
    },
    {
      label: "Flutterwave",
      value: "flutterwave",
      selected: false,
      extraFee: 0,
      disabled: true,
    },
    {
      label: "Debit Card",
      value: "debitcard",
      selected: false,
      extraFee: 0,
      disabled: true,
    },
  ];

  return (
    <PageMotion px={{ base: "8px", "1sm": "4px" }} pt={removeHeader ? "0" : "30px"}>
      <Layout _main={{ maxWidth: "720px", margin: "auto", minH: { sm: "auto", md: "85vh" } }}>
        {!removeHeader && (
          <Box m="0 auto" pos="relative">
            <ActionBar onBackClick={() => navigate(-1)} title="Pay" />
          </Box>
        )}

        {isSuccess && (
          <>
            <PositiveInfo mt="32px" py={{ base: "0", "2sm": "24px" }} border="1px solid transparent" borderBottomColor="#F2F4F3">
              Use the Merchant details below to complete your payment. Once you have made the transfer, upload proof of payment and
              proceed by clicking on the “<Span fontWeight="700">I have Paid</Span>” button below.
            </PositiveInfo>

            <Flex gridGap={{ base: "0", md: "8px" }} border="1px solid #F2F4F3" borderRadius="8px">
              <Box bg="#F8F9F9" width="100%" maxWidth="200px" p={{ base: "10px", md: "14px 0px 18px 16px" }}>
                <Text fontWeight="700" fontFamily="var(--bitmama-fonts-heading)" mb="24px">
                  PAY WITH
                </Text>

                <RadioGroup defaultValue="bank" onChange={handlePaymentMethod}>
                  {tabData.map(({ label, value, selected, disabled }) => {
                    return (
                      <Box fontWeight="500" key={label} borderBottom="1px solid #DBDBDB" padding="12px 8px 8px" mb="8px">
                        <Radio checked={selected} defaultChecked={selected} value={value} colorScheme="green" isDisabled={disabled}>
                          {label}
                        </Radio>
                      </Box>
                    );
                  })}
                </RadioGroup>
              </Box>

              <Box maxWidth="500px" p="14px 12px 14px 8px" width="100%">
                <PayWithBank data={data!} />
              </Box>
            </Flex>
          </>
        )}
      </Layout>

      <PoweredBy />
    </PageMotion>
  );
};

export default Pay;
